import { render, staticRenderFns } from "./DocumentExportsPaginateComponent.vue?vue&type=template&id=0422cb24"
import script from "./DocumentExportsPaginateComponent.js?vue&type=script&lang=js&external"
export * from "./DocumentExportsPaginateComponent.js?vue&type=script&lang=js&external"
import style0 from "./DocumentExportsPaginateComponent.vue?vue&type=style&index=0&id=0422cb24&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports